import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const paymentPoints = "api/paymentPoints";

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(`${paymentPoints}/getPoints${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => alertRequest(`${paymentPoints}/apply`, body(params));
const delItem = (params: {}) => alertRequest(`${paymentPoints}/delete`, body(params));
const getItem = ({ id }: { id: string }) => request(`${paymentPoints}/getPoint/${id}`, { method: "GET" });
const getPointsForSync = () => request(`${paymentPoints}/getPointsForSync`, { method: "GET" });
const syncPoints = () => request(`${paymentPoints}/getPointsForSync`, {});

export { apply, delItem, index, getItem, getPointsForSync, syncPoints };
